import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Bannerfrom from "../../components/bannerfrom";

function Banner(props) {
  return (
    <div className="services_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Retail App">
                <h1>Best Custom Retail Software Solutions in USA</h1>
              </div>
              <div className="banner_content_txt listing_flex">
                <p>
                  TekRevol offers advanced retail software solutions to improve
                  user experience and increase sales, including custom
                  omnichannel retail management software with a seamless POS and
                  billing system for inventory management and loyalty programs.
                </p>
                <ul>
                  <li>Improved UX & management</li>
                  <li>Increased sales</li>
                  <li>Omnichannel management</li>
                  <li>Loyalty program integration</li>
                </ul>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto ms-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
